<template>
  <m-basic-form
    @save="save"
    @remove="remove"
    :loadingMsg="loadingMsg"
    :loadingShow="loadingShow"
    :formId="ID"
  >
    <div class="row">
      <div class="col-5">
        <m-select
          :options="options.brokerage"
          v-model="form.BROKERAGEID"
          langlabel="mediate"
        />

        <m-input v-model="form.AGENTCODE" langlabel="mediateagentcode" />
        <m-input v-model="form.AGENTTITLE" langlabel="mediateagentname" />
        <m-input v-model="form.AUTHORTITLE" langlabel="mediateauthor" />
        <m-input v-model="form.TAXOFFICE" langlabel="taxoffice" />
        <m-input v-model="form.TAXNO" langlabel="taxno" />
        <m-input v-model="form.PHONE" langlabel="phone" />
        <m-input v-model="form.GSM" langlabel="gsm" />
        <m-input v-model="form.EMAIL" langlabel="email" />
        <m-yes-no v-model="form.ISACTIVE" langlabel="isactive" />
      </div>

      <div class="col-5">
        <m-select
          :options="options.city"
          v-model="form.CITYID"
          langlabel="city"
        />
        <m-select
          :options="options.county"
          v-model="form.COUNTYID"
          langlabel="county"
        />
        <m-textarea v-model="form.ADDRESS" langlabel="address" />
        <m-textarea v-model="form.DESCRIPTION" langlabel="description" />
      </div>
    </div>
  </m-basic-form>
</template>

<script>
import api from "../../api";
import swal from "sweetalert";
export default {
  mounted() {
    if (intval(this.$route.params.id) > 0) {
      this.ID = intval(this.$route.params.id);
      this.getBrokerageAgent(this.ID);
    }
    this.getBrokerage();
    this.getCity();
  },
  data() {
    return {
      ID: null,
      form: {
        BROKERAGEID: null,
        AGENTTITLE: null,
        AGENTCODE: null,
        CITYID: null,
        COUNTYID: null,
        ADDRESS: null,
        ISACTIVE: 1,
        TAXOFFICE: null,
        TAXNO: null,
        PHONE: null,
        GSM: null,
        EMAIL: null,
        AUTHORTITLE: null,
        DESCRIPTION: null,
      },
      loadingShow: false,
      loadingMsg: null,
      options: {
        city: [],
        county: [],
        brokerage: [],
      },
    };
  },
  methods: {
    getCity() {
      api
        .getCity()
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.city = res.data.data.rows.map((item) => {
              return { text: item.CITYNAME, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    getBrokerage() {
      api
        .getBrokerage()
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.brokerage = res.data.data.rows.map((item) => {
              return { text: item.BROKERAGETITLE, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    getCountyWidthCityId(id) {
      api
        .getCountyWidthCityId(id)
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.county = res.data.data.rows.map((item) => {
              return { text: item.COUNTYNAME, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    save() {
      this.loadingMsg = this.$t("dialog.savingrecord");
      this.loadingShow = true;
      api
        .saveBrokerageAgent(this.form, this.ID)
        .then((res) => {
          if (res.data.status) {
            if (this.ID == res.data.data.ID) {
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullyupdatedrecord"),
                "success"
              );
            } else {
              this.ID = res.data.data.ID;
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullysaverecord"),
                "success"
              );
            }
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    getBrokerageAgent(id) {
      this.loadingMsg = this.$t("dialog.fetchingdata");
      this.loadingShow = true;
      api
        .getBrokerageAgentOne(id)
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            const {
              BROKERAGEID,
              AGENTTITLE,
              AGENTCODE,
              CITYID,
              COUNTYID,
              ADDRESS,
              ISACTIVE,
              TAXOFFICE,
              TAXNO,
              PHONE,
              GSM,
              EMAIL,
              AUTHORTITLE,
              DESCRIPTION,
            } = res.data.data;
            this.form = {
              BROKERAGEID,
              AGENTTITLE,
              AGENTCODE,
              CITYID,
              COUNTYID,
              ADDRESS,
              ISACTIVE,
              TAXOFFICE,
              TAXNO,
              PHONE,
              GSM,
              EMAIL,
              AUTHORTITLE,
              DESCRIPTION,
            };
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    remove() {
      this.loadingMsg = this.$t("dialog.removingrecord");
      this.loadingShow = true;
      api
        .deleteBrokerageAgent(this.ID)
        .then((res) => {
          if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
  },
  watch: {
    "form.CITYID"(id) {
      this.getCountyWidthCityId(id);
    },
  },
};
</script>

<style></style>
